"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryTagList = void 0;
var React = require("react");
var buttons_1 = require("../buttons");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var typestyle_1 = require("typestyle");
var config_1 = require("../../config");
var generic_1 = require("../generic");
var CategoryTagList = (function (_super) {
    __extends(CategoryTagList, _super);
    function CategoryTagList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            editable: props.editable !== undefined ? props.editable : false,
        };
        return _this;
    }
    CategoryTagList.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var state = this.state;
        var selectedKeys = props.applied_tags.map(function (tag) { return tag.id; });
        var categoryList = (0, config_1.groupBy)(props.available_tags, function (t) { return t.category_name; })
            .filter(function (group) {
            var tags = group.members.map(function (tag) { return tag.id; });
            return state.editable || (0, config_1.intersection)(tags, selectedKeys).length > 0;
        })
            .map(function (group) {
            return (React.createElement(CategoryTagListElement, { editable: state.editable, category_name: group.key, category_exclusive: group.members[0].category_exclusive, category_mandatory: group.members[0].category_mandatory, tags: group.members, key: group.key, selectedTags: selectedKeys, onChange: props.onChange, onNoSelection: props.onNoSelection }));
        });
        return (React.createElement("div", { className: "CategoryTagList" },
            React.createElement(buttons_1.ActionButton, { className: "pl-0", onClick: function () { _this.toggleEditable(); } },
                React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                " ",
                gettext("Edit tags")),
            React.createElement("div", { className: "CategoryTagList__List" }, categoryList)));
    };
    CategoryTagList.prototype.toggleEditable = function () {
        var state = this.state;
        this.setState({ editable: !state.editable });
    };
    __decorate([
        mobx_1.action
    ], CategoryTagList.prototype, "toggleEditable", null);
    CategoryTagList = __decorate([
        mobx_react_1.observer
    ], CategoryTagList);
    return CategoryTagList;
}(React.Component));
exports.CategoryTagList = CategoryTagList;
var CategoryTagListElement = (function (_super) {
    __extends(CategoryTagListElement, _super);
    function CategoryTagListElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoryTagListElement.prototype.render = function () {
        var props = this.props;
        return (React.createElement("ul", { className: "CategoryTagListElement", key: props.category_name },
            React.createElement("li", { className: "CategoryTagListElement__Category" },
                props.category_name,
                props.category_mandatory &&
                    React.createElement(generic_1.Icon, { className: "mandatory-asterisk", name: generic_1.Icons.asterisk }),
                props.category_exclusive &&
                    React.createElement(generic_1.Icon, { className: "mandatory-tags ml-1", name: generic_1.Icons.tag })),
            React.createElement("ul", null,
                props.category_exclusive && !props.category_mandatory && props.editable &&
                    React.createElement("li", { className: "CategoryTagListElement__Item CategoryTagListElement__Item--editable" },
                        React.createElement("div", { className: "form-check" },
                            React.createElement("label", { className: "form-check-label" },
                                React.createElement("input", { type: "radio", className: "form-check-input", value: props.category_name, name: props.category_name, onChange: props.onNoSelection }),
                                " No Selection"))),
                props.tags
                    .filter(function (tag) {
                    var checked = props.selectedTags.indexOf(tag.id) >= 0;
                    return (!props.editable && checked) || props.editable;
                })
                    .map(function (tag) {
                    var checked = props.selectedTags.indexOf(tag.id) >= 0;
                    var editableModifier = (props.editable
                        ? "CategoryTagListElement__Item--editable"
                        : "");
                    return (React.createElement("li", { key: tag.id, className: (0, typestyle_1.classes)("CategoryTagListElement__Item", editableModifier) },
                        (!props.editable) && tag.name,
                        props.editable &&
                            React.createElement("div", { className: "form-check" },
                                props.category_exclusive &&
                                    React.createElement("label", { className: "form-check-label" },
                                        React.createElement("input", { type: "radio", className: "form-check-input", checked: checked, name: props.category_name, onChange: function (e) { return props.onChange(tag, e.target.checked); } }),
                                        " ",
                                        tag.name),
                                !props.category_exclusive &&
                                    React.createElement("label", { className: "form-check-label" },
                                        React.createElement("input", { type: "checkbox", className: "form-check-input", checked: checked, onChange: function (e) { return props.onChange(tag, e.target.checked); } }),
                                        " ",
                                        tag.name))));
                }))));
    };
    CategoryTagListElement = __decorate([
        mobx_react_1.observer
    ], CategoryTagListElement);
    return CategoryTagListElement;
}(React.Component));
